import React from 'react';
import { RefreshCw } from 'lucide-react';

export function PullToRefreshIndicator({ pullDistance, isRefreshing, threshold = 80 }) {
  if (pullDistance <= 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / threshold, 1);
  const rotation = pullDistance * 2;

  return (
    <div
      className="flex items-center justify-center overflow-hidden transition-all duration-200"
      style={{ height: isRefreshing ? 48 : pullDistance }}
    >
      <RefreshCw
        className={`h-5 w-5 text-primary transition-transform ${isRefreshing ? 'animate-spin' : ''}`}
        style={{
          transform: isRefreshing ? undefined : `rotate(${rotation}deg)`,
          opacity: progress,
        }}
      />
    </div>
  );
}
